export default {
  title: "Karussell",
  subtitle: "Kuratierte Kiosk-Startkarussell-Slides nach Region.",
  empty: "Noch keine Slides für diese Region.",
  emptyWritable: "Erstelle den ersten Karussell-Slide für diese Region.",
  schedule: {
    always: "Immer",
    from: "Ab",
    until: "Bis",
  },
  columns: {
    slide: "Slide",
    audience: "Zielgruppe",
    schedule: "Zeitraum",
    status: "Status",
  },
  status: {
    visible: "Jetzt sichtbar",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    scheduled: "Geplant",
    expired: "Beendet",
    draft: "Entwurf",
  },
  statusHints: {
    draft:
      "Als Entwurf gespeichert — nicht veröffentlicht, erscheint daher nie auf Kiosks.",
    visible:
      "Gerade live auf Kiosks (aktiviert und innerhalb des Zeitfensters).",
    scheduled:
      "Hat eine zukünftige Startzeit. Erscheint auf Kiosks, wenn diese Zeit erreicht ist und Aktiviert eingeschaltet ist.",
    disabled:
      "Erscheint nicht auf Kiosks — Aktiviert ist aus, oder die Endzeit ist bereits vorbei.",
  },
  categories: {
    all: "Alle Tabs",
    select: "Tabs auswählen",
  },
  structures: {
    all: "Alle Strukturen",
    count: "{{count}} Strukturen",
  },
  actions: {
    create: "Neuer Slide",
    edit: "Bearbeiten",
    delete: "Löschen",
    dragToReorder: "Zum Sortieren ziehen",
  },
  form: {
    createTitle: "Neuer Karussell-Slide",
    createDescription: "Slide für die Kioske der Region {{region}}.",
    editTitle: "Karussell-Slide bearbeiten",
    sections: {
      content: "Texte",
      contentHint: "Lokalisierter Titel und Beschreibung des Slides.",
      media: "Medien",
      mediaHint:
        "Zum Veröffentlichen erforderlich, sofern keine Aktivität verknüpft ist (dann wird deren Foto genutzt).",
      activity: "Verknüpfte Aktivität",
      activityHint: "Optional. Aktivität für CTA und Foto-Fallback suchen.",
      targeting: "Zielgruppe",
      targetingHint: "Auf welchen Tabs und Strukturen der Slide erscheint.",
      visibility: "Sichtbarkeit",
      visibilityHint: "Slide aktivieren und optional den Zeitraum festlegen.",
    },
    titleLabel: "Titel",
    descriptionLabel: "Beschreibung (optional)",
    photoCropDescription:
      "Rahmen Sie das Foto für das Kiosk-Home-Karussell-Banner (5:2).",
    activitySearch: "Nach Name, Inhaber oder Kategorie suchen…",
    activityNoResults: "Keine Aktivitäten passen zur Suche.",
    activityListEmpty: "Keine Aktivitäten in dieser Region.",
    activityClear: "Verknüpfte Aktivität entfernen",
    activityChange: "Ändern",
    activityInactive: "Inaktiv",
    showButton: "Button zum Öffnen der Aktivität anzeigen",
    showButtonHint:
      "Fügt auf dem Slide einen Button hinzu, der die Details der verknüpften Aktivität öffnet.",
    ignoreDistance: "Entfernung ignorieren",
    ignoreDistanceHint:
      "Diesen Slide im Karussell behalten, auch wenn die verknüpfte Aktivität weit vom Kiosk entfernt ist.",
    categoriesLabel: "Home-Tabs",
    categoriesHint:
      "Mindestens einen Tab wählen. Standardmäßig sind alle ausgewählt, damit der Slide überall erscheint. Bei verknüpfter Aktivität wird deren Kategorie vorbelegt.",
    showInAllStructures: "In allen Strukturen anzeigen",
    showInAllStructuresHint:
      "Wenn aus: wähle, in welchen Strukturen der Slide erscheint. Wenn an: sehen ihn alle Strukturen der Region.",
    structuresLabel: "Strukturen",
    structuresHint:
      "Wähle, in welchen Strukturen dieser Slide erscheinen darf.",
    enabled: "Aktiviert",
    enabledHint:
      "Wenn aus, bleibt der Slide auf Kiosks verborgen — auch wenn er veröffentlicht und im Zeitfenster ist.",
    startsAt: "Start (optional)",
    endsAt: "Ende (optional)",
    clearSchedule: "Löschen",
    translate: "Übersetzungen erzeugen",
    incompleteTranslationsTitle: "Übersetzungen unvollständig",
    incompleteTranslationsBody:
      "Der Titel muss in allen Sprachen ausgefüllt sein. Die Beschreibung muss in allen Sprachen vollständig oder leer sein. Fehlende Texte aus der bereits geschriebenen Sprache erzeugen, oder manuell fertigstellen.",
  },
  delete: {
    title: "Slide löschen?",
    body: "„{{title}}“ wird dauerhaft aus dem Karussell entfernt.",
    confirm: "Löschen",
    success: "Slide gelöscht",
  },
  toast: {
    created: "Slide erstellt",
    updated: "Slide gespeichert",
    draftSaved: "Entwurf gespeichert",
    reordered: "Reihenfolge aktualisiert",
  },
  errors: {
    loadError: "Karussell-Slides konnten nicht geladen werden",
    titleRequired: "Titel ist in allen Sprachen erforderlich",
    titleRequiredDraft: "Titel in mindestens einer Sprache hinzufügen",
    descriptionPartial:
      "Beschreibung muss in allen Sprachen vollständig oder leer sein",
    photoRequired:
      "Foto hochladen oder eine Aktivität verknüpfen, deren Foto genutzt wird.",
    categoriesRequired: "Mindestens einen Home-Tab auswählen",
    structuresRequired: "Wähle mindestens eine Struktur oder zeige es in allen",
    saveFailed: "Slide konnte nicht gespeichert werden",
  },
} as const;
